import apiClient from '@/api/apiClient.js';
import { getClinicalHistoriesId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    modelForm: {},
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    modelForm(state) {
      return state.modelForm;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
    insertModelForm(state, modelForm) {
      state.modelForm = modelForm;
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        const res = await apiClient.dataPatSchema();
        let schema = res.data;
        commit('insertSchema', schema);
      } catch (e) {
        return Promise.reject(e);
      }
    },

    async loadModelForm({ commit }, payload) {
      try {
        let model = {};
        if (payload === undefined) {
          model.usersPin = false;
        } else {
          const usersPin = payload.usersPin;
          model.usersPin = usersPin;
        }

        const id = getClinicalHistoriesId();
        const res = await apiClient.modelIdent(id, model);
        const modelForm = res.data.data;

        commit('auth/setHcpNum', modelForm.group1.clinicalHistories_hcp, { root: true });
        commit('insertModelForm', modelForm);
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
